<script setup></script>

<template>
  <svg width="48" height="32" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="32" rx="4" fill="white" />
    <path d="M28.3279 23.8615H19.6758V8.13782H28.3279V23.8615Z" fill="#6C6BBD" />
    <path
      d="M20.2221 15.9999C20.2221 12.8102 21.699 9.96898 23.9988 8.138C22.2579 6.74992 20.1047 5.9966 17.8878 6.00001C12.4267 6.00001 8 10.477 8 15.9999C8 21.5228 12.4267 26 17.8876 26C20.1046 26.0034 22.2579 25.25 23.9988 23.8618C21.699 22.0309 20.2221 19.1896 20.2221 15.9999Z"
      fill="#EB001B"
    />
    <path
      d="M39.9994 15.9999C39.9994 21.5228 35.5727 26 30.1118 26C27.8946 26.0033 25.7412 25.2499 24 23.8618C26.3 22.0309 27.7774 19.1896 27.7774 15.9999C27.7774 12.8102 26.3 9.96914 24.0002 8.13816C25.7413 6.75011 27.8947 5.99676 30.1118 6.00001C35.5727 6.00001 39.9996 10.477 39.9996 15.9999"
      fill="#0099DF"
    />
  </svg>
</template>
